module.exports = __webpack_public_path__ + "files/944d24f5e914e4a49cddde265c4bc115.png";